import {
  Switch as KendoSwitch,
  SwitchProps as KendoSwitchProps,
} from '@progress/kendo-react-inputs';

interface SwitchCustomProps {
  title?: string;
}

type SwitchProps = SwitchCustomProps & KendoSwitchProps;

export default function Switch(props: SwitchProps) {
  return (
    <span title={props.title}>
      <KendoSwitch {...props} />
    </span>
  );
}

Switch.defaultProps = {
  onLabel: '',
  offLabel: '',
};
